import { render } from "./VuexHiddenFormItem.vue?vue&type=template&id=8ac8f5ea"
import script from "./VuexHiddenFormItem.vue?vue&type=script&lang=js"
export * from "./VuexHiddenFormItem.vue?vue&type=script&lang=js"
script.render = render

export default script